export default {
  groupIdKey: 'id',
  groupTitleKey: 'name',
  itemIdKey: 'id',
  itemTitleKey: 'name',
  itemGroupKey: 'primaryTable',
  itemTimeStartKey: 'start',
  itemTimeEndKey: 'end',
};
